import type { ProcessoArbitralStatus } from '@/features/arbitral';

export interface SituacaoArbitral {
  id: string;
  empresaId: string;
  key: string;
  label: string;
  description: string | null;
  statusPai: string | null;
  active: boolean;
  isShared: boolean;
  escritorioIds: string[];
}

export interface EscritorioOpcao {
  id: string;
  nome: string;
}

export interface CriarSituacaoDto {
  label: string;
  description?: string | null;
  statusPai?: string | null;
  escritorioIds?: string[];
}

export interface EditarSituacaoDto {
  label?: string;
  description?: string | null;
  statusPai?: string | null;
}

export interface SituacoesArbitralState {
  items: SituacaoArbitral[];
  escritorios: EscritorioOpcao[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const STATUS_PAI_LABELS: Record<ProcessoArbitralStatus, string> = {
  PROCESSO_DISTRIBUIDO: 'Processo distribuído',
  TRIAGEM_EM_ANDAMENTO: 'Triagem em andamento',
  TRIAGEM_CONCLUIDA: 'Triagem concluída',
  EM_CITACAO: 'Em citação',
  EM_ANDAMENTO: 'Em andamento',
  SENTENCA_EMITIDA: 'Sentença emitida',
  CONCLUIDO: 'Concluído',
  NEGADO: 'Negado',
};

export const STATUS_PAI_OPCOES: ReadonlyArray<{ value: string; label: string }> = Object.entries(
  STATUS_PAI_LABELS,
).map(([value, label]) => ({ value, label }));
